var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav bar variants"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.00003 13H4.00003V20C4.00003 21.103 4.89703 22 6.00003 22H18C19.103 22 20 21.103 20 20V13H21C21.1978 12.9999 21.3911 12.9412 21.5555 12.8314C21.7199 12.7215 21.848 12.5653 21.9237 12.3826C21.9994 12.1999 22.0192 11.9989 21.9806 11.8049C21.942 11.611 21.8468 11.4328 21.707 11.293L12.707 2.29296C12.6142 2.20001 12.504 2.12627 12.3827 2.07596C12.2614 2.02565 12.1314 1.99976 12 1.99976C11.8687 1.99976 11.7387 2.02565 11.6173 2.07596C11.496 2.12627 11.3858 2.20001 11.293 2.29296L2.29303 11.293C2.15322 11.4328 2.05802 11.611 2.01945 11.8049C1.98088 11.9989 2.00068 12.1999 2.07635 12.3826C2.15202 12.5653 2.28016 12.7215 2.44457 12.8314C2.60898 12.9412 2.80228 12.9999 3.00003 13ZM10 20V15H14V20H10ZM12 4.41396L18 10.414V15L18.001 20H16V15C16 13.897 15.103 13 14 13H10C8.89703 13 8.00003 13.897 8.00003 15V20H6.00003V10.414L12 4.41396Z",
    fill: "#E9F4FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4678ec596543363af8548f01d2034f41.svg";
export { ForwardRef as ReactComponent };